module.exports = __webpack_public_path__ + "static/media/Icons_sms_integration.e2307f7f.svg";